import { graphql } from "gatsby"
import { gql } from "@apollo/client"

export const query = graphql`
  fragment profileEntrySummary on Craft_profiles_default_Entry {
    uid
    title
    uri
    profileRole

    profilePicture {
      ...mainFileUploadsAsset
    }
  }

  fragment profileEntryPage on Craft_profiles_default_Entry {
    profileBio

    profileLinks {
      ... on Craft_profileLinks_BlockType {
        uid
        linkType
        linkUrl
      }
    }

    profileCategory {
      uid
      title
      slug
    }

    seomatic {
      ...entrySEO
    }
  }
`

export const profileEntry = gql`
  fragment profileEntrySummary on profiles_default_Entry {
    uid
    title
    uri
    profileRole

    profilePicture {
      ...mainFileUploadsAsset
    }
  }

  fragment profileEntryPage on profiles_default_Entry {
    profileBio

    profileLinks {
      ... on profileLinks_BlockType {
        uid
        linkType
        linkUrl
      }
    }

    profileCategory {
      uid
      title
      slug
    }

    seomatic {
      ...entrySEO
    }
  }
`
